<template>
  <div class="alipay-container">
    <!-- 面包屑导航 -->
    <div class="breadcrumb-wrapper">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/Welcome' }">
          <i class="el-icon-s-home"></i> 首页
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <i class="el-icon-user"></i> 用户列表
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!-- 卡片内容 -->
    <el-card class="alipay-card" shadow="never">
      <!-- 搜索栏 -->
      <div class="search-bar">
        <el-form :inline="true" :model="searchForm" size="small">
          <el-form-item label="用户名/昵称">
            <el-input 
              v-model="searchForm.name" 
              placeholder="请输入用户名或昵称"
              prefix-icon="el-icon-search"
              clearable
              class="search-input"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="searchSubmit" icon="el-icon-search">搜索</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="warning" @click="addBeans" icon="el-icon-plus">增加金豆</el-button>
          </el-form-item>
        </el-form>
      </div>

      <!-- 统计卡片 -->
      <div class="stat-cards">
        <div class="stat-card">
          <div class="stat-icon total">
            <i class="el-icon-user"></i>
          </div>
          <div class="stat-info">
            <div class="stat-value">{{ total }}</div>
            <div class="stat-label">总用户数</div>
          </div>
        </div>
        <div class="stat-card">
          <div class="stat-icon money">
            <i class="el-icon-money"></i>
          </div>
          <div class="stat-info">
            <div class="stat-value">¥{{ totalMoney }}</div>
            <div class="stat-label">总余额</div>
          </div>
        </div>
        <div class="stat-card">
          <div class="stat-icon bean">
            <i class="el-icon-present"></i>
          </div>
          <div class="stat-info">
            <div class="stat-value">{{ totalBeans }}</div>
            <div class="stat-label">总金豆</div>
          </div>
        </div>
      </div>

      <!-- 表格 -->
      <div class="table-wrapper">
        <el-table
          ref="multipleTable"
          :data="tableLoadData"
          stripe
          border
          size="medium"
          :header-cell-style="headerCellStyle"
          :row-style="rowStyle"
          v-loading="loading"
          element-loading-text="加载中..."
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="50" align="center"></el-table-column>
          <el-table-column type="index" label="序号" width="60" align="center" :index="indexMethod"></el-table-column>
          
          <el-table-column label="用户ID" prop="user_id" width="100" align="center">
            <template slot-scope="scope">
              <span class="user-id">{{ scope.row.user_id }}</span>
            </template>
          </el-table-column>
          
          <el-table-column label="用户信息" min-width="200">
            <template slot-scope="scope">
              <div class="user-info">
                <div class="user-name">
                  <i class="el-icon-user-solid"></i>
                  <span>{{ scope.row.realname || '-' }}</span>
                </div>
                <div class="user-nickname">
                  <i class="el-icon-star-on"></i>
                  <span>{{ scope.row.nickname || '-' }}</span>
                </div>
              </div>
            </template>
          </el-table-column>
          
          <el-table-column label="用户名" prop="user_name" width="140" align="center">
            <template slot-scope="scope">
              <span class="username">{{ scope.row.user_name }}</span>
            </template>
          </el-table-column>
          
          <el-table-column label="余额" width="120" align="center">
            <template slot-scope="scope">
              <span class="money-amount">¥{{ scope.row.user_money || '0.00' }}</span>
            </template>
          </el-table-column>
          
          <el-table-column label="金豆数" width="120" align="center">
            <template slot-scope="scope">
              <span class="bean-amount">
                <i class="el-icon-present"></i>
                {{ scope.row.bean_num || 0 }}
              </span>
            </template>
          </el-table-column>
          
          <el-table-column label="注册日期" width="170" align="center">
            <template slot-scope="scope">
              <span class="time-text">{{ scope.row.reg_time | dateFormat }}</span>
            </template>
          </el-table-column>
          
          <el-table-column label="操作" width="120" align="center" fixed="right">
            <template slot-scope="scope">
              <el-button 
                type="text" 
                size="small" 
                class="edit-btn"
                @click="goEdit(scope.row)"
              >
                <i class="el-icon-edit-outline"></i> 编辑
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 空状态 -->
      <div v-if="tableLoadData.length === 0 && !loading" class="empty-state">
        <i class="el-icon-user"></i>
        <p>暂无用户数据</p>
      </div>

      <!-- 分页 -->
      <div class="pagination-wrapper" v-if="total > 0">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[10, 20, 30, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          :pager-count="5"
        >
        </el-pagination>
      </div>
    </el-card>

    <!-- 用户编辑弹框 -->
    <eUserForm
      :formData="formData"
      :visible.sync="visible"
      :title="title"
      :closeForm="closeForm"
    />

    <!-- 增加金豆弹框 -->
    <el-dialog
      title="增加金豆"
      :visible.sync="beansDialogVisible"
      width="460px"
      :close-on-click-modal="false"
      class="alipay-dialog"
      @closed="handleBeansDialogClosed"
    >
      <div class="dialog-content">
        <div class="dialog-icon">
          <i class="el-icon-present"></i>
        </div>
        <div class="selected-info" v-if="selectedUsers.length > 0">
          <div class="info-title">已选择用户 ({{ selectedUsers.length }})：</div>
          <div class="info-users">
            <el-tag 
              v-for="user in selectedUsers" 
              :key="user.user_id" 
              size="small"
              type="primary"
              effect="plain"
            >
              {{ user.realname || user.nickname || user.user_name }}
            </el-tag>
          </div>
        </div>
        <div v-else class="no-selected">
          <i class="el-icon-info"></i>
          <span>请先在表格中勾选需要增加金豆的用户</span>
        </div>
        
        <el-form :model="beansForm" :rules="beansRules" ref="beansForm" label-width="90px" label-position="right" v-if="selectedUsers.length > 0">
          <el-form-item label="增加数量" prop="beans">
            <el-input-number 
              v-model="beansForm.beans" 
              :min="1" 
              :max="99999"
              :step="100"
              placeholder="请输入增加数量"
              style="width: 100%;"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="备注">
            <el-input 
              type="textarea" 
              v-model="beansForm.remark" 
              placeholder="请输入备注信息"
              :rows="2"
              maxlength="100"
              show-word-limit
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      
      <div slot="footer" class="dialog-footer">
        <el-button size="medium" @click="beansDialogVisible = false">取 消</el-button>
        <el-button size="medium" type="primary" @click="submitBeans" :loading="beansSubmitting" :disabled="selectedUsers.length === 0">
          <i class="el-icon-check"></i> 确认增加
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import moment from 'moment'
import eUserForm from "../common/eUserForm.vue"

export default {
  name: "userList",
  components: {
    eUserForm
  },
  data() {
    return {
      loading: false,
      
      // 搜索表单
      searchForm: {
        name: "",
      },
      
      // 统计数据
      totalMoney: 0,
      totalBeans: 0,
      
      // 表格数据
      tableLoadData: [],
      pageNum: 1,
      pageSize: 10,
      total: 0,
      
      // 选中的用户
      multipleSelection: [],
      
      // 用户编辑弹框
      formData: {},
      title: '',
      visible: false,
      
      // 增加金豆弹框
      beansDialogVisible: false,
      beansSubmitting: false,
      beansForm: {
        beans: 100,
        remark: ''
      },
      beansRules: {
        beans: [
          { required: true, message: '请输入增加数量', trigger: 'blur' },
          { type: 'number', min: 1, message: '数量必须大于0', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    selectedUsers() {
      return this.tableLoadData.filter(user => 
        this.multipleSelection.some(selected => selected.user_id === user.user_id)
      )
    }
  },
  created() {
    this.DataList()
  },
  filters: {
    dateFormat(add_time) {
      if (!add_time) return ""
      return moment(add_time * 1000).format("YYYY-MM-DD HH:mm:ss")
    }
  },
  methods: {
    // 表格样式配置
    headerCellStyle() {
      return {
        background: '#f5f7fa',
        color: '#1f2d3d',
        fontWeight: '500',
        fontSize: '14px',
        borderBottom: '1px solid #e4e7ed'
      }
    },
    rowStyle() {
      return {
        cursor: 'pointer'
      }
    },
    
    // 表格选中变化
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    
    // 计算统计数据
    calculateStats() {
      if (!this.tableLoadData || this.tableLoadData.length === 0) {
        this.totalMoney = 0
        this.totalBeans = 0
        return
      }
      
      this.totalMoney = this.tableLoadData.reduce((sum, item) => {
        return sum + (parseFloat(item.user_money) || 0)
      }, 0).toFixed(2)
      
      this.totalBeans = this.tableLoadData.reduce((sum, item) => {
        return sum + (parseInt(item.bean_num) || 0)
      }, 0)
    },
    
    indexMethod(index) {
      return (this.pageNum - 1) * this.pageSize + index + 1
    },
    
    // 获取用户列表
    DataList() {
      this.loading = true
      const param = {
        access_token: sessionStorage.getItem('token'),
        company_id: sessionStorage.getItem('company_id'),
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      }
      
      if (this.searchForm.name) {
        param.keyword = this.searchForm.name
      }
      
      this.$axios.userList(param).then(res => {
        this.loading = false
        if (res.code == 200) {
          this.tableLoadData = res.data.data || []
          this.total = res.data.total || 0
          this.calculateStats()
        }
      }).catch(error => {
        this.loading = false
        console.log(error)
      })
    },
    
    handleSizeChange(newSize) {
      this.pageSize = newSize
      this.pageNum = 1
      this.DataList()
    },
    
    handleCurrentChange(newPage) {
      this.pageNum = newPage
      this.DataList()
    },
    
    searchSubmit() {
      this.pageNum = 1
      this.DataList()
    },
    
    // 编辑用户
    goEdit(row) {
      this.title = "编辑用户"
      this.formData = {
        user_id: row.user_id,
        realname: row.realname,
        nickname: row.nickname,
        user_name: row.user_name,
        parent_id: row.parent_id,
        parent_name: row.parent ? row.parent.realname : '',
        user_money: row.user_money,
        bean_num: row.bean_num
      }
      this.visible = true
    },
    
    closeForm() {
      this.title = ""
      this.visible = false
      this.DataList()
    },
    
    // 增加金豆弹框
    addBeans() {
      if (this.multipleSelection.length === 0) {
        this.$message.warning('请先在表格中勾选需要增加金豆的用户')
        return
      }
      
      this.beansForm = {
        beans: 100,
        remark: ''
      }
      this.beansDialogVisible = true
    },
    
    handleBeansDialogClosed() {
      this.$refs.beansForm?.resetFields()
    },
    
    // 提交增加金豆
    submitBeans() {
      this.$refs.beansForm.validate((valid) => {
        if (valid) {
          this.beansSubmitting = true
          
          const param = {
            access_token: sessionStorage.getItem('token'),
            company_id: sessionStorage.getItem('company_id'),
            user_ids: this.multipleSelection.map(user => user.user_id).join(','),
            bean_num: this.beansForm.beans,
            remark: this.beansForm.remark
          }
          
          this.$axios.addUserBeans(param).then(res => {
            if (res.code == 200) {
              this.$message.success(res.msg)
              this.beansDialogVisible = false
              this.DataList()
              // 清空选中
              this.$refs.multipleTable.clearSelection()
              this.multipleSelection = []
            } else {
              this.$message.error(res.msg)
            }
          }).catch(error => {
            console.log(error)
            this.$message.error('操作失败')
          }).finally(() => {
            this.beansSubmitting = false
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.alipay-container {
  padding: 16px 20px;
  background: #f5f7fa;
  min-height: calc(100vh - 60px);
}

.breadcrumb-wrapper {
  margin-bottom: 16px;
  .el-breadcrumb { font-size: 14px; i { margin-right: 4px; } }
}

.alipay-card {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  &:hover { box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.08); }
  .el-card__body { padding: 20px 24px; }
}

// 搜索栏样式
.search-bar {
  background: #f8f9fc;
  padding: 16px 20px;
  border-radius: 12px;
  margin-bottom: 20px;
  
  .el-form-item { margin-bottom: 0; }
  .search-input { width: 260px; }
  .search-input ::v-deep .el-input__inner { border-radius: 20px; }
  
  .el-button--primary {
    background: #1677ff; border-color: #1677ff; border-radius: 20px; padding: 8px 20px;
    &:hover { background: #4096ff; border-color: #4096ff; }
  }
  .el-button--warning {
    background: #e6a23c; border-color: #e6a23c; border-radius: 20px; padding: 8px 20px;
    &:hover { background: #ebb563; border-color: #ebb563; }
  }
}

// 统计卡片
.stat-cards {
  display: flex; gap: 20px; margin-bottom: 24px; flex-wrap: wrap;
  .stat-card {
    flex: 1; min-width: 150px; background: linear-gradient(135deg, #fff 0%, #f8f9fc 100%);
    border-radius: 16px; padding: 20px; display: flex; align-items: center; gap: 16px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04); transition: all 0.3s ease;
    &:hover { transform: translateY(-2px); box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08); }
    .stat-icon {
      width: 48px; height: 48px; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 24px; color: #fff;
      &.total { background: linear-gradient(135deg, #1677ff, #4096ff); }
      &.money { background: linear-gradient(135deg, #00b578, #1acd8c); }
      &.bean { background: linear-gradient(135deg, #e6a23c, #ebb563); }
    }
    .stat-info {
      .stat-value { font-size: 28px; font-weight: 700; color: #1f2d3d; line-height: 1.2; }
      .stat-label { font-size: 13px; color: #8c8f98; margin-top: 4px; }
    }
  }
}

// 表格样式
.table-wrapper { margin-bottom: 20px; min-height: 350px; }
.el-table { border-radius: 12px; overflow: hidden; &::before { display: none; } th { background: #fafbfc !important; font-weight: 500; } td { border-bottom: 1px solid #f0f0f0; } .el-table__row { transition: background 0.2s; &:hover { background: #f8f9fc; } } }

.user-id { font-family: monospace; font-weight: 500; color: #1677ff; }
.user-info { .user-name { display: flex; align-items: center; gap: 6px; margin-bottom: 4px; i { color: #1677ff; font-size: 14px; } span { font-weight: 500; } } .user-nickname { display: flex; align-items: center; gap: 6px; i { color: #e6a23c; font-size: 12px; } span { font-size: 12px; color: #8c8f98; } } }
.username { font-weight: 500; color: #1f2d3d; }
.money-amount { color: #00b578; font-weight: 600; }
.bean-amount { display: flex; align-items: center; justify-content: center; gap: 4px; i { color: #e6a23c; } }
.time-text { font-size: 12px; color: #8c8f98; }
.edit-btn { color: #1677ff; i { margin-right: 4px; } &:hover { color: #4096ff; } }

.empty-state { text-align: center; padding: 60px 20px; color: #c0c4cc; i { font-size: 64px; } p { margin-top: 16px; font-size: 14px; } }
.pagination-wrapper { display: flex; justify-content: flex-end; padding-top: 16px; border-top: 1px solid #f0f0f0; .el-pagination .el-pager li.active { background: #1677ff; color: #fff; } }

// 弹框样式
.alipay-dialog .el-dialog {
  border-radius: 20px; overflow: hidden; box-shadow: 0 20px 40px rgba(0, 0, 0, 0.08);
  .el-dialog__header { background: linear-gradient(135deg, #1677ff 0%, #4096ff 100%); padding: 20px 24px; .el-dialog__title { color: #fff; font-size: 18px; font-weight: 500; } }
  .el-dialog__body { padding: 24px; }
  .el-dialog__footer { padding: 16px 24px 24px; border-top: 1px solid #f0f0f0; }
}

.dialog-icon { text-align: center; margin-bottom: 20px; i { font-size: 56px; color: #e6a23c; background: #fdf6ec; padding: 16px; border-radius: 60px; } }

.selected-info { margin-bottom: 20px; padding: 12px; background: #f8f9fc; border-radius: 8px; .info-title { font-size: 13px; color: #606266; margin-bottom: 8px; } .info-users { display: flex; flex-wrap: wrap; gap: 8px; } }
.no-selected { text-align: center; padding: 30px; background: #fdf6ec; border-radius: 8px; color: #e6a23c; i { margin-right: 8px; } }

.dialog-footer {
  display: flex; justify-content: flex-end; gap: 12px;
  .el-button { border-radius: 24px; padding: 9px 24px; }
  .el-button--primary { background: #1677ff; border-color: #1677ff; &:hover { background: #4096ff; border-color: #4096ff; } }
}
</style>